import { useDispatch, useSelector } from 'react-redux';
import { OnBoardingLayout, OnBoardingTitle } from '../OnBoardingLayout';
import ListStock from './ListStock';
import Search from './Search';
import { ButtonNext } from '../OnBoardingLayout/styled';

// Store
// Store profile to get on boarding data
import { selectors as profileSelectors } from 'lib/entities/profile';

// Store onboarding to handle next steps
import { effects as onBoardingEffects } from 'lib/entities/onboarding';
import { ONBOARDING_MAX_STEP } from '../constants';

function DiscoverStock() {
  const dispatch = useDispatch();

  // get current on boarding progress
  const { data: dataProfile } = useSelector(profileSelectors);
  const { onboarding: progress } = dataProfile;

  const handleClickBack = () => {
    const prevStep = progress - 1;

    dispatch(onBoardingEffects.userSkipOnboarding(prevStep));
  };

  const handleFinish = () => {
    if (progress < ONBOARDING_MAX_STEP) {
      const nextStep = progress + 1;

      dispatch(onBoardingEffects.userSkipOnboarding(nextStep));
    }
  };

  return (
    <OnBoardingLayout className="ob-discover">
      <OnBoardingTitle onClickBack={handleClickBack}>
        Discover Company Stock
        <span>We recommend you to follow at least 5 stocks</span>
      </OnBoardingTitle>
      <Search />
      <ListStock />
      <ButtonNext height="40px" mx="auto" onClick={handleFinish}>
        Finish
      </ButtonNext>
    </OnBoardingLayout>
  );
}

export default DiscoverStock;
